import React, {useEffect, useState} from 'react';
import { MdSearch, MdHouse, MdShoppingBag, MdDelete} from 'react-icons/md';

function CartItem({src, name, size, price, quantity, id, removeFromCart, reduceQuantity, updateQuantity}){
   return(
    <div className='flex width-100 navbar border-bottom cart-item'>
       <div className='flex one center'>
         <img src={src} className='car-img' id="car-img" ></img>
       </div>
       <div className='flex one column'>
        <div className='flex one center'>
            <span className='bold medium-txt'>{name}</span>
        </div>
         <div className='flex one center'>
            <span className='medium-txt'>Size: {size}</span>
         </div>
          <div className='flex one center'>
            <span className='bold medium-txt'>{price}</span>
          </div>
       </div>
       <div className='flex one column'>
        <div className='flex one'></div>
        <div className='flex one center'>
            <span>{quantity}</span>
        </div>
        <div className='flex one'>
            <div className='flex one center shadow' onClick={()=>{reduceQuantity(id, size)}}>
                    <span className='brown-txt bold'>-</span>
            </div>
           
            <div className='flex one center shadow' onClick={()=>{updateQuantity(id,size)}}>
                    <span className='bold brown-txt'>+</span>
            </div>
            <div className='flex one center shadow' onClick={()=>{removeFromCart(id,size)}}>
                <MdDelete size={15} className='brown'/>
            </div>
        </div>
       </div>
    </div>
   )
}

export default CartItem